import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  indicator: {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  activeIcon: {
    width: "16px",
    height: "16px",
    display: "flex",
    overflow: "hidden",
    position: "relative",
    marginRight: "6px",
    "&:before": {
      content: "''",
      width: "100%",
      height: "100%",
      backgroundColor: theme.custom.color.apple,
      opacity: 0.5,
      display: "block",
      position: "absolute",
      top: 0,
      borderRadius: "50%",
    },
    "&:after": {
      content: "''",
      width: "8px",
      height: "8px",
      backgroundColor: theme.custom.color.apple,
      display: "block",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      borderRadius: "50%",
    },
  },
  inActiveIcon: {
    "&:before": {
      backgroundColor: theme.palette.error.main,
    },
    "&:after": {
      backgroundColor: theme.palette.error.main,
    },
  },
  icon: {
    display: "flex",
    marginRight: "6px",
    fontSize: "24px",
  },
  label: {
    display: "flex",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
    textTransform: "capitalize",
  },
  helperText: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: 400,
    display: "block",
  },
  inactive: {
    color: theme.palette.error.main,
  },
  active: {
    color: theme.custom.color.apple,
  },
  error: {
    color: theme.palette.error.main,
  },
  pending: {
    color: theme.palette.primary.main,
  },
  warning: {
    color: theme.palette.error.main,
  },
  success: {
    color: theme.custom.color.apple,
    marginTop: "20px",
  },
  failed: {
    color: theme.palette.error.main,
    marginTop: "20px",
  },
  yes: {
    color: theme.custom.color.apple,
    margin: "20px 0 10px 0",
  },
  no: {
    color: theme.palette.error.main,
    margin: "20px 0 10px 0",
  },
  low: {
    color: theme.custom.color.apple,
    textTransform: "none",
  },
  med: {
    color: theme.palette.primary.main,
    textTransform: "none",
  },
  high: {
    color: theme.palette.error.main,
    textTransform: "none",
  },
}));
